import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Stack,
  Typography,
} from '@mui/material';
import { CloseBtn } from 'modules/common/components/CloseBtn';
import { useTranslation } from 'modules/i18n';
import { translation } from './translation';
import { useCancelWithdrawal } from '../Withdraw/hooks/useCancelWithdrawal';

interface ICancelWithdrawalModalProps {
  open: boolean;
  onClose: () => void;
}

export const CancelWithdrawalModal = ({
  open,
  onClose,
}: ICancelWithdrawalModalProps): JSX.Element => {
  const { t, keys } = useTranslation(translation);
  const { cancelWithdraw, isLoading } = useCancelWithdrawal({
    onSuccess: onClose,
  });

  return (
    <Dialog open={open} onClose={onClose}>
      <CloseBtn onClick={onClose} />
      <DialogContent
        sx={{
          minWidth: {
            xs: 300,
            md: 520,
          },
        }}
      >
        <Stack gap={1.5}>
          <Typography variant="h6" component="h2" textAlign="center">
            {t(keys.title)}
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            {t(keys.message, undefined, true)}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          flexDirection: 'column',
          gap: 1.5,
        }}
      >
        <Button
          variant="contained"
          color="secondary"
          onClick={onClose}
          fullWidth
          disabled={isLoading}
        >
          {t(keys.cancel)}
        </Button>

        <Button
          variant="contained"
          color="primary"
          onClick={cancelWithdraw}
          fullWidth
          disabled={isLoading}
          endIcon={isLoading ? <CircularProgress size={16} /> : undefined}
          sx={{ '&&': { ml: 0 } }}
        >
          {t(keys.confirm)}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
